import { useEffect, useRef, useState, useCallback } from 'react';

export function useWebSocket(url) {
  const wsRef = useRef(null);
  const [data, setData] = useState(null);
  const [connected, setConnected] = useState(false);

  const connect = useCallback(() => {
    if (!url) return;
    const ws = new WebSocket(url);
    wsRef.current = ws;

    ws.onopen = () => setConnected(true);
    ws.onclose = () => {
      setConnected(false);
      setTimeout(connect, 3000);
    };
    ws.onerror = () => ws.close();
    ws.onmessage = (e) => {
      try { setData(JSON.parse(e.data)); } catch {}
    };
  }, [url]);

  useEffect(() => {
    connect();
    return () => {
      wsRef.current?.close();
    };
  }, [connect]);

  return { data, connected };
}
